import type { SelectedAddons } from '../../state/types';

type Price = string | number;

// Resolves a percentage deposit to an amount, mirroring the server's
// PricingUtils.resolvePercentDeposit: scale-2 HALF_UP for every currency, JPY included.
// Integer minor units keep it exact, so the displayed amount matches the charged one.
// Replicated from bookings-catalog-bo's computePercentDeposit so the editor can't drift.
export const computePercentDeposit = (price: Price, percent: Price): number => {
  const priceMinorUnits = Math.round(Number(price) * 100);
  const percentHundredths = Math.round(Number(percent) * 100);

  if (!priceMinorUnits || !percentHundredths) {
    return 0;
  }

  const depositMinorUnits = Math.floor(
    (priceMinorUnits * percentHundredths + 5000) / 10000,
  );

  return depositMinorUnits / 100;
};

// The add-on part of the percentage-deposit base, mirroring the server's sumAddOnPrices.
// `?? 1` rather than `|| 1`: an explicit quantity of 0 must stay 0, since that's the quantity
// eCom is given in the line item's modifier and therefore what it charges.
export const sumSelectedAddonPrices = (
  selectedAddons?: SelectedAddons,
): number => {
  if (!selectedAddons) {
    return 0;
  }

  const totalMinorUnits = Object.values(selectedAddons).reduce(
    (groupsTotal, groupAddons) =>
      groupsTotal +
      Object.values(groupAddons).reduce(
        (groupTotal, { price, quantity }) =>
          groupTotal + Math.round(Number(price) * 100 || 0) * (quantity ?? 1),
        0,
      ),
    0,
  );

  return totalMinorUnits / 100;
};
